/**
 * 生成唯一标识符字符串
 * @param {*} len Number, 生成的字符串长度
 * @param {*} radix Number, 生成的进制数, 枚举值：2、10、16
 * 示例：
 * uuid() | 'A1706576-4AE0-42D2-A96B-6DFDFDBF5C93'
 * uuid(8, 2) | '00100111'
 * uuid(8, 10) | '95519825'
 * uuid(6, 16) | 'DD03FD'
 */

export const uuid = function (len, radix) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
  radix = radix || chars.length;

  if (len) {
    for (let i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    let r;

    uuid[8] = '-';
    uuid[13] = '-';
    uuid[18] = '-';
    uuid[23] = '-';
    uuid[14] = '4';

    for (let i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('');
};
